import React, { useEffect, useRef } from 'react';
import { Button, Card, Col, Alert } from 'react-bootstrap';
import { Form, Field } from 'formik';
import RadioGroupField from 'shared/components/form/fields/radio-group';
import TextField from 'shared/components/form/fields/text';

const radioOptions = [
  { label: 'Yes', value: true },
  { label: 'No', value: false }
];

const practiceOrGroupRadio = [
  { label: 'Practices', value: 'practices' },
  { label: 'Groups', value: 'groups' }
];

const SearchForm = ({ isValid, values, submitForm, loading, error }) => {
  const { practiceOrGroup, showWithRemovedDate, showWithNoMdmId, showWithNoOffice } = values.practice;

  // Re-run the search whenever a radio changes so the table always reflects the
  // filters shown. Skip the initial render, and skip when there is no search text
  // yet (the text field is required, so there is nothing to search for).
  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    if (isValid && values.practice.search) {
      submitForm();
    }
    // Only the radios should trigger this; typing in the search box should not.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [practiceOrGroup, showWithRemovedDate, showWithNoMdmId, showWithNoOffice]);

  return (
    <Form className="registration-form">
      <Card>
        <Card.Body>
          <div className="row">
            <Col xs={12} sm={8} style={{ paddingRight: '30px' }}>
              <Field
                name="practice.search"
                maxLength={64}
                label="Name, Zip, NPI, Email, MDM"
                component={TextField}
              />
            </Col>
            <Col xs={12} sm={4}>
              <Field
                name="practice.practiceOrGroup"
                label="Search"
                component={RadioGroupField}
                elems={practiceOrGroupRadio}
              />
            </Col>
          </div>
          <div className="row">
            <Col xs={12} sm={4}>
              <Field
                name="practice.showWithRemovedDate"
                label="Show Practices With Removed Date: "
                component={RadioGroupField}
                elems={radioOptions}
              />
            </Col>
            <Col xs={12} sm={4}>
              <Field
                name="practice.showWithNoMdmId"
                label="Show Practices With No MDM ID: "
                component={RadioGroupField}
                elems={radioOptions}
              />
            </Col>
            <Col xs={12} sm={4}>
              <Field
                name="practice.showWithNoOffice"
                label="Show Practices With No Office: "
                component={RadioGroupField}
                elems={radioOptions}
              />
            </Col>
          </div>
          <div className="row">
            <Col>
              <Alert variant="danger" show={!!error}>
                <i className="fa fa-fw fa-exclamation-triangle" /> {error}
              </Alert>
            </Col>
          </div>
          <div className="row">
            <Col>
              <Button type="submit" disabled={!isValid || loading}>
                {loading ? (
                  <span>
                    <i className="fa fa-fw fa-circle-notch fa-spin" />
                  </span>
                ) : (
                  'Search'
                )}
              </Button>
            </Col>
          </div>
        </Card.Body>
      </Card>
    </Form>
  );
};

export default SearchForm;
